import * as LazyComponents from '../../frontends/ProviderSearch/routes/PSXHome/lazyComponents';
import { useCurrentMember } from '../../hooks/useCurrentMember';
import { CareCategories, LOB } from '../Constants';

export type Props = {
  selectedChipValue?: string;
  showPremiumCareDisclaimer?: boolean;
  isVisionCare?: boolean;
  ratingSection?: boolean;
  isViewAllDisclaimer?: boolean;
  isLandingPage?: boolean;
  isVirtualVisit?: boolean;
};

export const DisclaimerContent = ({
  selectedChipValue,
  showPremiumCareDisclaimer = false,
  isVisionCare = false,
  ratingSection = false,
  isViewAllDisclaimer = false,
  isLandingPage = false,
  isVirtualVisit = false,
}: Props) => {
  const { lineOfBusiness = '' } = useCurrentMember();

  const isSearchResultsPath =
    typeof window !== 'undefined' &&
    (window.location.pathname.includes('/browse/results') ||
      window.location.pathname.includes('/results/mapview'));

  const chipValueFromQuery = (() => {
    if (!isSearchResultsPath) return '';

    const params = new URLSearchParams(window.location.search);
    return params.get('chipValue') ?? '';
  })();

  const resolvedSelectedChipValue = isSearchResultsPath
    ? chipValueFromQuery || selectedChipValue
    : selectedChipValue;

  const resolvedIsVisionCare =
    resolvedSelectedChipValue === CareCategories.VISION || isVisionCare;
  const resolvedIsVirtualVisit =
    resolvedSelectedChipValue === CareCategories.VIRTUAL_VISIT ||
    isVirtualVisit;

  if (!resolvedSelectedChipValue) {
    return (
      <LazyComponents.DisclaimersContainer
        isLandingPage={isLandingPage}
        isViewAllDisclaimer={isViewAllDisclaimer}
        isVirtualVisit={resolvedIsVirtualVisit}
        isVisionCare={resolvedIsVisionCare}
        ratingSection={ratingSection}
        showPremiumCareDisclaimer={showPremiumCareDisclaimer}
      />
    );
  }

  const getDisclaimer = (selectValue) => {
    switch (selectValue) {
      case CareCategories.VIRTUAL_VISIT:
        return (
          <LazyComponents.DisclaimersContainer
            isVirtualVisit
            showPremiumCareDisclaimer
          />
        );
      case CareCategories.BEHAVIORAL_HEALTH:
        return <LazyComponents.DisclaimersContainer />;
      case CareCategories.PRIMARY_CARE:
      case CareCategories.MEDICAL_SPECIALISTS:
        return (
          <LazyComponents.DisclaimersContainer
            showPremiumCareDisclaimer={true}
          />
        );
      case CareCategories.DENTAL:
        return <LazyComponents.DisclaimersContainer />;
      case CareCategories.VISION:
        return <LazyComponents.DisclaimersContainer isVisionCare />;
      default:
        return null;
    }
  };

  switch (lineOfBusiness) {
    case LOB.MNR:
      return (
        <LazyComponents.DisclaimersContainer
          isLandingPage
          isVisionCare={resolvedIsVisionCare}
        />
      );
    case LOB.CNS:
      return <LazyComponents.DisclaimersContainer />;
    default:
      return getDisclaimer(resolvedSelectedChipValue);
  }
};
